<template>
  <aha-modal
    :mobile-max-height="true"
    :no-margin-padding="true"
    :visible-overflow="true"
    size="4xl"
    :title="title"
    :backable="openTabContent"
    classes-modal="only-mobile-back-button"
    @back="back"
    @hide="hideModal"
  >
    <div
      class="tab-content tab-content__editor-share-v2-modal"
    >
      <div class="side-left" :class="{'mobile-open-side-center': openTabContent}">
        <div class="side-left-container">
          <div
            class="side-left-item"
            :class="{'active': activeTab === 'inviteAudience'}"
            @click="selectItem('inviteAudience')"
          >
            <span class="rectangle"></span>
            <aha-icon
              class="item-icon"
              name="phone-share"
            >
            </aha-icon>
            {{ $i18nPresenter.t("Invite Audience") }}
          </div>
          <div
            class="side-left-item"
            :class="{'active': activeTab === 'addEditor'}"
            @click="selectItem('addEditor')"
            v-if="inviteToEditVisible"
          >
            <span class="rectangle"></span>
            <aha-icon
              class="item-icon"
              name="invite-v2"
            >
            </aha-icon>
            {{ $i18nPresenter.t("Add Collaborators") }}
          </div>
          <div
            class="side-left-item"
            :class="{'active': activeTab === 'shareSlides'}"
            @click="selectItem('shareSlides')"
          >
            <span class="rectangle"></span>
            <aha-icon
              class="item-icon"
              name="share-v2"
            />
            {{ $i18nPresenter.t("Share Slides") }}
          </div>
          <div
            class="side-left-item"
            :class="{'active': activeTab === 'publishTemplate'}"
            @click="selectItem('publishTemplate')"
          >
            <span class="rectangle"></span>
            <aha-icon
              class="item-icon"
              name="community-v2"
            />
            {{ $i18nPresenter.t("Publish") }}
          </div>
        </div>
      </div>
      <div class="side-center h-full" :class="{'mobile-open-tab-content': openTabContent}">
        <SideCenterInviteAudience :presentation="presentation" v-if="activeTab === 'inviteAudience'">
        </SideCenterInviteAudience>
        <SideCenterAddEditor
          :presentation="presentation"
          @prepareDataForInviteTeamModal="prepareDataForInviteTeamModal"
          v-if="activeTab === 'addEditor'"
        ></SideCenterAddEditor>
        <SideCenterShareSlides
          :presentation="presentation"
          :source="source"
          v-if="activeTab === 'shareSlides'"
          @hideModal="hideModal"
        />
        <SideCenterPublishTemplate :presentation="presentation" v-if="activeTab==='publishTemplate'">
        </SideCenterPublishTemplate>
      </div>
    </div>
  </aha-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SideCenterInviteAudience from '@/components-v2/editor-share-v2/SideCenterInviteAudience'
import SideCenterAddEditor from '@/components-v2/editor-share-v2/SideCenterAddEditor'
import SideCenterShareSlides from '@/components-v2/editor-share-v2/SideCenterShareSlides'
import SideCenterPublishTemplate from '@/components-v2/editor-share-v2/SideCenterPublishTemplate.vue'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import constants from '@/constant'

export default {
  components: {
    SideCenterPublishTemplate,
    SideCenterInviteAudience,
    SideCenterShareSlides,
    SideCenterAddEditor,
  },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    source: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      toBeInvitedMembers: null,
      activeTab: 'inviteAudience',
      openTabContent: false,
      title: this.$i18nPresenter.t('Share'),
      mapTitle: {
        inviteAudience: this.$i18nPresenter.t('Invite Audience'),
        addEditor: this.$i18nPresenter.t('Add Collaborators'),
        shareSlides: this.$i18nPresenter.t('Share Slides'),
        publishTemplate: this.$i18nPresenter.t('Publish'),
      },
      mappingEventAction: {
        inviteAudience: 'Share menu > Invite Audience',
        addEditor: 'Share menu > Add Collaborators',
        shareSlides: 'Share menu > Share Slides',
        publishTemplate: 'Share menu > Publish',
      },
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    isMobile() {
      return window.innerWidth < 768
    },
    inviteToEditVisible() {
      return this.currentUser.identifyProvider !== 'skoletube'
    },
  },
  created() {
    if (this.$store.state.presentation.defaultTabShare) {
      this.selectItem(this.$store.state.presentation.defaultTabShare)
      this.$store.state.presentation.defaultTabShare = ''
    }

    let canViewerShare = false
    let canEditPresentation = false
    if (this.presentation) {
      const canRenamePresentation =
        this.presentation.permissions &&
        this.presentation.permissions.includes(constants.permissions.RENAME_PRESENTATION)
      const isDisableEditPresentation =
        this.presentation.takenOverBy && this.currentUser.id !== this.presentation.takenOverBy
      canViewerShare = canRenamePresentation
      canEditPresentation = !isDisableEditPresentation && canRenamePresentation
    }
    this.setCanViewerShare(canViewerShare)
    this.setCanEditPresentation(canEditPresentation)
  },
  methods: {
    ...mapActions([
      'setCanViewerShare',
      'setCanEditPresentation',
    ]),
    tracking(item) {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        this.mappingEventAction[item], null, null, {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
        },
      )
    },
    selectItem(item) {
      this.activeTab = item
      this.openTabContent = true
      if (this.isMobile) {
        this.title = this.mapTitle[item]
      }
      this.tracking(item)
    },
    back() {
      this.title = 'Share'
      this.openTabContent = false
    },
    hideModal() {
      this.$emit('hideModal', {
        toBeInvitedMembers: this.toBeInvitedMembers,
      })
    },
    prepareDataForInviteTeamModal({ toBeInvitedMembers }) {
      this.toBeInvitedMembers = toBeInvitedMembers
    },
  },
}
</script>

<style lang="scss" scoped>

.tab-content__editor-share-v2-modal {
  display: flex;
  // height: fit-content;
  height: 100%;
  min-height: 500px;
  border-top: 1px solid rgba(239, 241, 247, 1);

  .side-left {
    flex-shrink: 0;
    border-right: 1px solid rgba(239, 241, 247, 1);
    width: 200px;

    .side-left-container {
      .side-left-item {
        &:hover {
          cursor: pointer;
        }

        &.active {
          background: rgba(236, 244, 254, 1);
          font-weight: bold;

          .item-icon {
            color: rgba(25, 31, 45, 1);
          }

          .rectangle {
            visibility: visible;
          }
        }

        height: 48px;
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 14px;

        .item-icon {
          margin-left: 10px;
          margin-right: 10px;
          @apply text-base-70;
        }

        .rectangle {
          height: 100%;
          width: 8px;
          background: rgba(52, 142, 246, 1);
          visibility: hidden;
        }
      }
    }
  }

  .side-center {
    flex-grow: 1;
    padding: 15px 20px 20px;
  }
}

@media (max-width: 767.98px) {
  .tab-content__editor-share-v2-modal {
    display: flex;
    flex-direction: column;

    .side-left {
      width: 100%;
      margin-bottom: 15px;

      &.mobile-open-side-center {
        display: none;
      }

      .side-left-container {
        .side-left-item {
          &.active {
            background: inherit;
            font-weight: inherit;

            .item-icon {
              @apply text-base-70
            }

            .rectangle {
              visibility: hidden;
            }
          }
        }
      }
    }

    .side-center {
      display: none;

      &.mobile-open-tab-content {
        display: block;
      }
    }
  }
}
</style>
